import { parse } from 'date-fns';

import { formatTime } from 'state/intl/translations';

export const timeToString = (time: string) => {
  try {
    return formatTime(parse(time, 'HH:mm', new Date()));
  } catch {
    return time;
  }
};
